import {
  put,
  takeEvery,
  all,
  select
} from 'redux-saga/effects'

import * as Actions from 'actions/email_templates_library'
import * as Selectors from 'selectors'

export function* fetchMoreTemplatesStart({ payload }) {
  let shared

  // Coming from the template library module we don't have a payload, so we need to get the shared value from the state.
  if (payload) {
    shared = payload.shared
  } else {
    shared = yield select(Selectors.getETLibraryShowPublic)
  }

  yield put(Actions.increaseTemplatesPage())
  yield put(Actions.fetchTemplatesStart({ shared }))
}

export function* watchFetchMoreTemplatesStart() {
  yield takeEvery(Actions.fetchMoreTemplatesStart, fetchMoreTemplatesStart)
}

export default function* filterSaga() {
  yield all([
    watchFetchMoreTemplatesStart()
  ])
}
